import dayjs from 'dayjs';

import { getMMYYYYformattedDate } from './getMMYYYYformattedDate';

export const getGanttHeaderLabels = (startDate: dayjs.Dayjs, endDate: dayjs.Dayjs) => {
  const labels = [];
  let start = startDate.startOf('month');
  let end = endDate.endOf('month');

  if (start.isSame(end, 'month') && start.isSame(end, 'year')) {
    end = end.subtract(1, 'month').add(1, 'year');
  }

  while (start.isBefore(end)) {
    labels.push(getMMYYYYformattedDate(start));
    start = start.add(1, 'month');
  }

  return labels;
};
